import { defineStore } from 'pinia'
import { type User, roleService } from '@/service'
import router from '../router'
import { ecp } from '@/utils/rangy'
import i18n from '@/i18n'

export type LoginStore = {
  userInfo: User['userInfo'] | null
  permissions: User['permission']
}

const useLoginStore = defineStore('loginStore', {
  state: (): LoginStore => {
    return {
      userInfo: null,
      permissions: []
    }
  },
  actions: {
    async login({ username }: { username: string }) {
      let res = await roleService.login({ username })
      if (roleService.isSuccess(res)) {
        this.userInfo = res.data.user.userInfo
        this.permissions = res.data.user.permission
        if (!this.permissions.length)
          ecp.utils.message.error(i18n.global.t('login.permissionInsufficient'))
      }
      return this.permissions
    },
    loginOut() {
      this.userInfo = null
      this.permissions = []
      router.push({
        name: 'login'
      })
    }
  },
  persist: {
    enabled: true,
    strategies: [
      {
        key: 'loginStore',
        storage: localStorage
      }
    ]
  }
})

export default useLoginStore
